// SearchLayoutComponent.js
'use client';
import { connect } from 'react-redux';
import withRouter from '../component/WithRouter.jsx';
import { goBack } from 'redux-first-history';

import { replace } from '../action/navigationAction.js';
import setSearch from '../action/setSearch.js';
import getOperationData from '../selector/getOperationData.js';
import { breakpoint } from '../style/variables.js';
import SearchLayoutComponent from '../component/SearchLayoutComponent.jsx';
import withSearchQuery from '../component/WithSearchQuery.jsx';

const mapStateToProps = (state, { query, location: { search }, match }) => {
  const type = match.params.type;
  const category = match.params?.category || '';
  const searchParams = new URLSearchParams(search);
  const deviceWidth = getOperationData(state, ['device'], 'width');
  return {
    type,
    category,
    query,
    urlQuery: searchParams.get('q'),
    isOnMobile: deviceWidth <= breakpoint.mobile,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    replace: (...args) => dispatch(replace(...args)),
    setSearch: data => dispatch(setSearch(data)),
    goBack: () => dispatch(goBack()),
  };
};

export default withSearchQuery(
  withRouter(
    connect(mapStateToProps, mapDispatchToProps)(SearchLayoutComponent)
  )
);
